import { useQuery } from '@tanstack/react-query';
import { getTestCaseHistory } from '../../modules/entity-details';
import HistoryFeed from '../../ui/data/history/HistoryFeed';
import DetailsCard from '../../ui/layout/DetailsCard';

export const TestCaseHistory = ({ entityId }) => {
  const { data = [], isLoading } = useQuery({
    queryKey: ['testcase-history', entityId],
    queryFn: async () => {
      const res = await getTestCaseHistory(entityId);
      return res.data || [];
    },
    enabled: !!entityId,
    staleTime: 1000 * 60 * 5, // 5 min cache
  });

  return (
    <DetailsCard
      title="Test Case History"
    >
      <HistoryFeed
        entries={data}
        isLoading={isLoading}
      />
    </DetailsCard>
  );
};